var _rect, _rect2, _g, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2018_7003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.6667,
    y: 3.33325,
    width: 13.3333,
    height: 13.3333,
    transform: "rotate(90 16.6667 3.33325)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2018_7003)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2018_7003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6667,
    y: 3.33325,
    width: 13.3333,
    height: 13.3333,
    transform: "rotate(90 16.6667 3.33325)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2018_7003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71461 10.7857C3.49855 10.5696 3.39052 10.3077 3.39052 10C3.39052 9.6923 3.49855 9.43041 3.71461 9.21435L9.21433 3.71463C9.43039 3.49857 9.69228 3.39054 10 3.39054C10.3077 3.39054 10.5696 3.49857 10.7857 3.71463L16.2854 9.21435C16.5015 9.43041 16.6095 9.6923 16.6095 10C16.6095 10.3077 16.5015 10.5696 16.2854 10.7857L10.7857 16.2854C10.5696 16.5015 10.3077 16.6095 10 16.6095C9.69228 16.6095 9.43039 16.5015 9.21433 16.2854L3.71461 10.7857ZM4.50028 10L10 15.4997L15.4997 10L10 4.5003L4.50028 10Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71461 10.7857C3.49855 10.5696 3.39052 10.3077 3.39052 10C3.39052 9.6923 3.49855 9.43041 3.71461 9.21435L9.21433 3.71463C9.43039 3.49857 9.69228 3.39054 10 3.39054C10.3077 3.39054 10.5696 3.49857 10.7857 3.71463L16.2854 9.21435C16.5015 9.43041 16.6095 9.6923 16.6095 10C16.6095 10.3077 16.5015 10.5696 16.2854 10.7857L10.7857 16.2854C10.5696 16.5015 10.3077 16.6095 10 16.6095C9.69228 16.6095 9.43039 16.5015 9.21433 16.2854L3.71461 10.7857ZM4.50028 10L10 15.4997L15.4997 10L10 4.5003L4.50028 10Z",
    fill: "#334155"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5.94482,
    width: 5.73482,
    height: 5.73482,
    transform: "rotate(45 10 5.94482)",
    fill: "#334155"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondFull);
export default __webpack_public_path__ + "static/media/Diamond Full.9c3981a82603ba8afedb1da52d3ebc4e.svg";
export { ForwardRef as ReactComponent };